export default "__VITE_ASSET__Cy$WYeUy__"